module.exports = __webpack_public_path__ + "static/media/tools-text.977824f2.svg";